import { render, staticRenderFns } from "./dark_moder.vue?vue&type=template&id=5bf6fa92&"
import script from "./dark_moder.vue?vue&type=script&lang=js&"
export * from "./dark_moder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports